function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { LogLevel as AbrLogLevel } from '@sky-uk-ott/vpt-abr';
import { checkIsManifestVodType } from '../../utils/playback-type';
import { LogLevel } from '@sky-uk-ott/core-video-sdk-js-logger';
export var applyAbrStreamTypeOverrides = function(playbackType, abrConfig) {
    var _ref = abrConfig !== null && abrConfig !== void 0 ? abrConfig : {}, vodOverride = _ref.vodOverride, liveOverride = _ref.liveOverride, defaultConfig = _ref.defaultConfig;
    var abrOverrideToUse = checkIsManifestVodType(playbackType) ? vodOverride : liveOverride;
    return abrOverrideToUse !== null && abrOverrideToUse !== void 0 ? abrOverrideToUse : defaultConfig;
};
function getAbrLogLevel(logLevel) {
    switch(logLevel){
        case LogLevel.Silent:
            return AbrLogLevel.Silent;
        case LogLevel.Error:
            return AbrLogLevel.Error;
        case LogLevel.Warn:
            return AbrLogLevel.Warn;
        case LogLevel.Breadcrumb:
            return AbrLogLevel.Breadcrumb;
        case LogLevel.Info:
            return AbrLogLevel.Info;
        case LogLevel.Verbose:
            return AbrLogLevel.Verbose;
    }
}
export function getAbrProviderConfig(logger, abrProviderConfig) {
    var logHandlers = logger.getLogHandlers();
    var logLevelOverride = abrProviderConfig === null || abrProviderConfig === void 0 ? void 0 : abrProviderConfig.logging.logLevelOverride;
    logHandlers = logHandlers.map(function(handler) {
        return _object_spread_props(_object_spread({}, handler), {
            logLevel: logLevelOverride !== null && logLevelOverride !== void 0 ? logLevelOverride : getAbrLogLevel(handler.logLevel)
        });
    });
    return {
        logging: {
            debugMode: abrProviderConfig === null || abrProviderConfig === void 0 ? void 0 : abrProviderConfig.logging.debugMode,
            logHandlers: logHandlers
        }
    };
}

//# sourceMappingURL=abr-config-helpers.js.map